"use client";
import Link from "next/link";
import { createDesign } from "@/app/actions/designs";
import { createOutfit } from "@/app/actions/outfits";
import type { FabAction } from "@/lib/fab";
import { SubmitButton } from "./SubmitButton";

function Plus() {
  return (
    <svg className="fab-icon" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M8 2.5v11M2.5 8h11" />
    </svg>
  );
}

const newDress = createDesign.bind(null, "dress");

/** Bottom-right floating action: the current page's own "+" (lib/fab.ts picks it). */
export function Fab({ action }: { action: FabAction }) {
  if (action.kind === "new-design") {
    return (
      <form action={newDress}>
        <SubmitButton className="fab"><Plus />{action.label}</SubmitButton>
      </form>
    );
  }
  if (action.kind === "new-outfit") {
    return (
      <form action={createOutfit}>
        <SubmitButton className="fab"><Plus />{action.label}</SubmitButton>
      </form>
    );
  }
  return <Link href={action.href} className="fab"><Plus />{action.label}</Link>;
}
